import { render, staticRenderFns } from "./CategoryShape.vue?vue&type=template&id=13cb44c8&scoped=true"
import script from "./CategoryShape.vue?vue&type=script&lang=js"
export * from "./CategoryShape.vue?vue&type=script&lang=js"
import style0 from "./CategoryShape.vue?vue&type=style&index=0&id=13cb44c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb44c8",
  null
  
)

export default component.exports